// extracted by mini-css-extract-plugin
module.exports = {"Alert":"rdsW9a","General":"E2kqIV","Ul":"e9aapo"};